import { render, staticRenderFns } from "./BlogNew.vue?vue&type=template&id=2308b92e&"
import script from "./BlogNew.vue?vue&type=script&lang=js&"
export * from "./BlogNew.vue?vue&type=script&lang=js&"
import style0 from "./BlogNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports